const releaseDateFormatter = new Intl.DateTimeFormat('uk-UA', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
});

export const formatReleaseDate = (value?: string | null) => {
    if (!value) return null;

    const date = new Date(`${value}T00:00:00`);
    return Number.isNaN(date.getTime())
        ? null
        : releaseDateFormatter.format(date);
};
